<template>
	<div class="statistics-panel">
		<el-row :gutter="20">
			<el-col :span="12" v-for="stat in statItems" :key="stat.label">
				<div class="stat-card">
					<div class="stat-value" :class="stat.className">{{ stat.value }}</div>
					<div class="stat-label">{{ stat.label }}</div>
				</div>
			</el-col>
		</el-row>

		<div class="detail-stats" v-if="statistics.detail">
			<el-divider>详细统计</el-divider>
			<el-table :data="statistics.detail" size="mini" border>
				<el-table-column prop="category" label="分类" width="120"></el-table-column>
				<el-table-column prop="total" label="总数" width="80" align="center"></el-table-column>
				<el-table-column prop="counted" label="已盘点" width="80" align="center"></el-table-column>
				<el-table-column prop="different" label="有差异" width="80" align="center"></el-table-column>
				<el-table-column prop="amount" label="差异金额" width="100" align="right">
					<template slot-scope="scope">
						¥{{ scope.row.amount.toFixed(2) }}
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'StatisticsPanel',
		props: {
			statistics: Object
		},
		computed: {
			statItems() {
				return [{
						label: '总商品数',
						value: this.statistics.total,
						className: 'total'
					},
					{
						label: '已盘点数',
						value: this.statistics.counted,
						className: 'counted'
					},
					{
						label: '有差异数',
						value: this.statistics.different,
						className: 'different'
					},
					{
						label: '差异金额',
						value: `¥${this.statistics.differenceAmount.toFixed(2)}`,
						className: 'amount'
					}
				]
			}
		}
	}
</script>

<style lang="less" scoped>
	.statistics-panel {
		padding: 10px;
	}

	.stat-card {
		text-align: center;
		padding: 20px;
		background: #f8f9fa;
		border-radius: 8px;
		margin-bottom: 15px;

		.stat-value {
			font-size: 24px;
			font-weight: bold;
			margin-bottom: 8px;

			&.total {
				color: #409EFF;
			}

			&.counted {
				color: #67C23A;
			}

			&.different {
				color: #E6A23C;
			}

			&.amount {
				color: #F56C6C;
			}
		}

		.stat-label {
			font-size: 14px;
			color: #606266;
		}
	}

	.detail-stats {
		margin-top: 20px;
	}
</style>